import { DialogContent, DialogTitle } from "@mui/material"
import { OkCancel } from "lib/@components/okCancel"
import { useState } from "react"
import { ProjectBridgeUploadFilePicker } from "./project-bridge-upload-file-picker"

export function ProjectBridgeUploadDialog() {
    const [value, setValue] = useState(createInitialValue)

    return (
        <>
            <DialogTitle>Upload Project Bridge JSON</DialogTitle>
            <DialogContent>
                <ProjectBridgeUploadFilePicker value={value} onChange={setValue} />
            </DialogContent>
            <OkCancel
                value={value.fileData ? value : undefined}
                okCaption="Upload Project Bridge JSON"
                okDisabled={isUploadDisabled}
            />
        </>
    )
}

function createInitialValue() {
    return { fileName: null, fileData: null }
}

function isUploadDisabled(value) {
    return !value?.fileData
}
